import { render } from "./ProductItem.vue?vue&type=template&id=09b57e88&scoped=true&ts=true"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=09b57e88&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b57e88"]])

export default __exports__